import { isNotEmpty, isNotNil } from 'ramda';

import { Currency, TsrctQuoteInput, TsrctQuoteItemUpdatableStatus, TsrctQuoteMode } from '@/generated/gql/graphql';
import { getMaxDate } from '~/util/date/getMaxDate';
import { getMinDate } from '~/util/date/getMinDate';

import { QuoteFormData } from './components/QuoteDetailsForm/QuoteDetailsForm.schema';

export const mutationDataFromQuoteForm = ({
  quote,
}: {
  quote: NonNullable<QuoteFormData['quote']>;
  quoteMode: TsrctQuoteMode;
}): TsrctQuoteInput => {
  return {
    // BUG-1160: Enforcing undefined, null and empty string are passed to graphql as null
    supplierReference:
      isNotNil(quote.supplierReference) && isNotEmpty(quote.supplierReference) ? quote.supplierReference : null,
    currency: quote.currency as Currency,
    paymentTerms: (quote.paymentTerms ?? []).map((terms) => ({
      discount: terms.discount.toString(),
      daysToPayment: terms.daysToPayment,
    })),
    shipmentTerms: {
      earlyDeliveryAt: getMinDate(quote?.lineItems?.map((item) => item.shipmentTerms?.earlyDeliveryAt) ?? []),
      lateDeliveryAt: getMaxDate(quote?.lineItems?.map((item) => item.shipmentTerms?.lateDeliveryAt) ?? []),
    },
    lineItems: (quote.lineItems ?? []).map((item) => {
      const updatableStatusValues = [
        TsrctQuoteItemUpdatableStatus.NOT_REQUESTED,
        TsrctQuoteItemUpdatableStatus.REQUESTED,
      ];
      const statusStr = String(item.status);
      const updatableStatus = updatableStatusValues.some((s) => s === statusStr)
        ? (item.status as unknown as TsrctQuoteItemUpdatableStatus)
        : undefined;
      return {
        description: item.description,
        position: item.position,
        pricePerUnit: item.pricePerUnit?.toString(),
        quantity: item.quantity.toString(),
        shipmentTerms: {
          earlyDeliveryAt: item.shipmentTerms?.earlyDeliveryAt,
          lateDeliveryAt: item.shipmentTerms?.lateDeliveryAt,
        },
        title: item.title,
        unitId: item.unitId,
        ...(updatableStatus !== undefined && { status: updatableStatus }),
      };
    }),
  };
};
